import React, { memo } from "react";
import DashboardTabsContainer from "./NewDashboard/DashboardTabsContainer";
import PatientListCycles from "./NewDashboard/PatientListCycles/PatientListCycles";

const Home = () => {
  let UserPreferences = localStorage.getItem("UserPreferences");

  if (UserPreferences) {
    UserPreferences = JSON.parse(window.atob(UserPreferences));
  }

  return (
    <>
      <div className="page_main_content p-0">
        <div className="page_inner_content border-0 p-0">
          <PatientListCycles />

          <div className="dashboard_tab_list">
            <DashboardTabsContainer />
          </div>
        </div>
      </div>

      {/* <div className="page_main_content">
        {UserPreferences?.other ? (
          <Dashboard />
        ) : (
          <Tabs
            defaultActiveKey="1"
            activeKey={activeTab}
            onTabClick={(key) => setActiveTab(key)}
          >
            {items.map((item) => (
              <Tabs.TabPane tab={item.label} key={item.key}>
                {item.children}
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}
      </div> */}
    </>
  );
};

export default memo(Home);
